import { Component, inject, Input, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { LoaderService } from '@tcc-mono/shared/ui/services';
import { withLoading } from '@tcc-mono/shared/utils';
import { AnimalSelection } from '@tcc-mono/vandijk/shared/data-access/models';
import { AnimalSelectionRepository } from '@tcc-mono/vandijk/shared/data-access/state';
import { TransportGroupRvoResultDialogComponent } from '@tcc-mono/vandijk/web/office/feature/transport-groups/transport-group-rvo-result-dialog';
import dayjs from 'dayjs';
import { from, switchMap, take, tap } from 'rxjs';

@Component({
  templateUrl: './animal-selection-export-dialog.component.html',
  styleUrls: ['./animal-selection-export-dialog.component.scss']
})
export class AnimalSelectionExportDialogComponent implements OnInit {
  private readonly _fb: FormBuilder = inject(FormBuilder);
  private readonly _repo: AnimalSelectionRepository = inject(AnimalSelectionRepository);
  private readonly _loading: LoaderService = inject(LoaderService);
  private readonly _modalCtrl: ModalController = inject(ModalController);

  @Input() public selection: AnimalSelection;

  public form: FormGroup;

  public ngOnInit(): void {
    this.form = this._initForm();
  }

  public save() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const fv = this.form.value;

    const body = {
      ...fv
    };

    this._repo.export(this.selection.id, body)
      .pipe(
        withLoading(this._loading),
        take(1),
        switchMap((results: any) => {
          return from(
            this._modalCtrl.create({
              component: TransportGroupRvoResultDialogComponent,
              componentProps: {
                rvoResults: results.data
              }
            })
          ).pipe(tap(modal => modal.present()));
        })
      )
      .subscribe({
        next: () => this._modalCtrl.dismiss()
      });
  }

  private _initForm(): FormGroup {
    return this._fb.group({
      date: [dayjs().format('YYYY-MM-DD'), [Validators.required]],
    });
  }
}
